import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import ItemsSortableList from "./ItemsSortableList";

type Props = {
    subCat: any;
    openModalEditCategory: (cat:any)=>void;
    deleteCategory: (id:number)=>void;
    toggleActiveCategory: (cat:any)=>void;
    openModalAddItem: (id:number)=>void;
    openModalEditItem: (item:any, idSub:number)=>void;
    deleteItem: (id:number)=>void;
    toggleActiveItem: (item:any)=>void;
    openForType: (type:number, url:string, subUrl?: string | null | undefined)=>void;
    getNameTypeFile: (id:number)=>string;
};

const SortableSubCategoryItem: React.FC<Props> = ({ subCat, ...props }) => {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition
    } = useSortable({ id: subCat.id });

    const style: React.CSSProperties = {
        transform: CSS.Transform.toString(transform),
        transition
        
    };

    return (
        <>
        {
            subCat.isSeparator !== true ?
            <>
                <div ref={setNodeRef} style={style} className="alert alert-success">

                    <span {...attributes} {...listeners} style={{cursor:'grab', marginRight:10, float:'left', fontSize:36}}>
                        <i className="mdi mdi-drag"></i>
                    </span>

                    <span style={{float:'left', marginRight:10, cursor:'pointer'}} title="Editar Categoria" onClick={()=>{props.openModalEditCategory(subCat)}}> 
                        <i className="mdi mdi-pencil-box" style={{color:(subCat?.isHighlight??false)?'#24a524':'#061e06', fontSize:20}}></i>
                    </span>

                    <span style={{float:'right'}}> 
                        <span style={{display:'block',cursor: 'pointer'}} onClick={() => props.deleteCategory(subCat.id)}>
                            <i className="mdi mdi-delete-circle" style={{color:'#c52828', fontSize:20}}></i>
                        </span>
                        <span
                            style={{cursor: 'pointer',display:'block' }}
                            onClick={() => props.toggleActiveCategory(subCat)}
                        >
                            <i
                                className={`mdi ${subCat.active ? "mdi-toggle-switch" : "mdi-toggle-switch-off"}`}
                                style={{
                                    fontSize: 26,
                                    color: subCat.active ? "#28a745" : "#999"
                                }}
                            />
                        </span>
                    </span>
                        <p style={{color:(subCat?.isHighlight??false)?"#ffffff":"", marginBottom:0}} title="Editar Itens da Categoria">
                            <>
                                {subCat.title}
                                <span style={{display:'block', color:'#8f8c8c'}}>
                                    {subCat.subTitle}
                                </span>
                                <span style={{display:'block', color:'#ffffff'}}>
                                    Item: {subCat.itemLinks?.length || 0}
                                </span>
                            </>
                        </p>

                    <ItemsSortableList subCat={subCat} {...props} />

                </div>
            </> :
            <>
                <div ref={setNodeRef} style={{...style, overflow: 'auto'}} className="alert alert-warning">

                    <span {...attributes} {...listeners} style={{cursor:'grab', marginRight:10, float:'left', fontSize:36}}>
                        <i className="mdi mdi-drag"></i>
                    </span>

                    <span style={{float:'left', marginRight:10, cursor:'pointer'}} title="Editar Categoria" onClick={()=>{props.openModalEditCategory(subCat)}}> 
                        <i className="mdi mdi-pencil-box" style={{color:(subCat?.isHighlight??false)?'#24a524':'#061e06', fontSize:20}}></i>
                    </span>

                    <span style={{float:'right'}}> 
                        <span style={{display:'block',cursor: 'pointer'}} onClick={() => props.deleteCategory(subCat.id)}>
                            <i className="mdi mdi-delete-circle" style={{color:'#c52828', fontSize:20}}></i>
                        </span>
                        <span
                            style={{cursor: 'pointer',display:'block' }}
                            onClick={() => props.toggleActiveCategory(subCat)}
                        >
                            <i
                                className={`mdi ${subCat.active ? "mdi-toggle-switch" : "mdi-toggle-switch-off"}`}
                                style={{
                                    fontSize: 26,
                                    color: subCat.active ? "#28a745" : "#999"
                                }}
                            />
                        </span>
                    </span>
                        <p style={{color:(subCat?.isHighlight??false)?"#ffffff":"", marginBottom:0}} title="Editar Itens da Categoria">
                            <>
                                {subCat.title}
                            </>
                        </p>

                </div>
            </>
        }
        </>
        
    );
};


export default SortableSubCategoryItem;